import React from 'react'
import Project from '../../components/Project'
import { COMPUTER_VISION_PATH } from '../../routes'
import { otherProjectsWithout } from '../otherProjectsCardsInformation'

export default class ToyotaProject extends React.Component {
    name(){
        return 'toyota'
    }

    service(){
        return 'computerVision'
    }

    texts() {
        return this.props.texts
    }

    image() {
        return this.props.image
    }

    solutionsTexts() {
        return this.texts()['solutions']
    }

    otherProjects() {
        return otherProjectsWithout(this.name(),
            this.service(), this.solutionsTexts())
    }

    render() {
        return (
            <Project
                texts={this.texts()}
                projectImg={this.image()}
                otherProjects={this.otherProjects()}
                projectAreaPath={COMPUTER_VISION_PATH}
            />
        )
    }
}
